import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import ExperienceAccordion from "./ExperienceAccordion";
import SkillOrb from "./SkillOrb";
import TypeWriter from "../TypeWriter";
import TabWindow from "../TabWindow";

function About() {

  return (
    <>
      <Particle />
      <Container fluid className="about-section" id="about">
        <TabWindow
          activeTabId="about"
          activeFileName="experience.js"
          activeIcon="📁"
          language="JAVASCRIPT"
          lineCount="92"
        >

          {/* Experience Section */}
          <ExperienceAccordion />

          {/* Interactive Skills Globe Section */}
          <section style={{ paddingBottom: "30px" }}>
            <p className="terminal-cmd section-cmd">
              <span className="terminal-dollar">$</span>
              <TypeWriter text=" npm run skills --interactive" speed={40} />
            </p>
            <h1 className="project-heading" style={{ textAlign: "center", marginBottom: "40px" }}>
              <TypeWriter text="Professional " speed={55} cursor={false} />
              <TypeWriter text="Skills Globe" speed={55} className="purple" tag="strong" />
            </h1>
            <SkillOrb />
          </section>

        </TabWindow>
      </Container>
    </>
  );
}

export default About;
